import src from "IMAGE";
export default { src, width: 1003, height: 732, blurWidth: 0, blurHeight: 0};
